import { render, staticRenderFns } from "./CartCheckout.vue?vue&type=template&id=52d8ddea&scoped=true"
import script from "./CartCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./CartCheckout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8ddea",
  null
  
)

export default component.exports